<template>
  <dropdown
    v-model="activeSize"
    class="c-size-picker-dropdown"
    placeholder="Select a Size"
    :options="sizeOptions"
  />
</template>

<script>
import SizePickerMixin from './SizePickerMixin'
import Dropdown from '../dropdown/Dropdown'
export default {
  components: {
    Dropdown
  },
  mixins: [
    SizePickerMixin
  ],
  computed: {
    activeSize: {
      get() {
        return this.activeOption
      },
      set(width) {
        this.$emit('select', width)
      }
    },
    sizeOptions() {
      const options = this.options
      let result = []
      for (let value of options) {
        result.push({
          label: `Size ${value}`,
          value
        })
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.c-size-picker-dropdown {}
</style>
